import jApi from 'jamespot-user-api';

import styled from 'styled-components';
import { JRCButtonDropdownOptionProps } from 'jamespot-react-components';
import { officeConfigurationInitialState } from '../components/OfficeConfigurationPrompt';

import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Widget } from 'jamespot-front-business';
import { commonComponentsRegistry } from '../../../../registry/CommonRegistry';
import { WidgetHeader } from '../components/WidgetHeader';

const ButtonDropdown = commonComponentsRegistry.getLazyComponent('ButtonDropdown');
const Tooltip = commonComponentsRegistry.getLazyComponent('Tooltip');

export const UIDropdown = styled.div`
    margin-right: ${(props) => props.theme.space.sm}px;
    button {
        background: ${(props) => props.theme.color.white};
    }
`;

export const WidgetContactCardDavHeader = ({
    uniqid,
    isConfigurationValid = false,
    handleLogout,
}: {
    uniqid: string;
    isConfigurationValid: boolean;
    handleLogout: () => void;
}) => {
    const intl = useIntl();
    const dispatch = useDispatch();
    const onLogout = () => {
        dispatch(Widget.slice.actions.setWidgetState({ uniqid, loading: true }));
        jApi.office.setConfiguration(officeConfigurationInitialState).finally(handleLogout);
    };

    const options: JRCButtonDropdownOptionProps[] = [
        { label: intl.formatMessage({ id: 'WIDGET_Prompt_Logout' }), onClick: onLogout },
    ];

    return (
        <WidgetHeader
            uniqid={uniqid}
            dropdown={() => {
                return (
                    isConfigurationValid && (
                        <UIDropdown>
                            <Tooltip
                                position={'left'}
                                description={intl.formatMessage({ id: 'WIDGET_Prompt_Dropdown' })}>
                                <ButtonDropdown
                                    small
                                    smallOpenDirection="left"
                                    options={options}
                                    icon={'icon-cogwheel'}
                                    label={''}
                                    color="primary"
                                    variant="outlined"
                                />
                            </Tooltip>
                        </UIDropdown>
                    )
                );
            }}
        />
    );
};
